import { ApiService } from "../../services/api.service";
import Cookies from "universal-cookie";
import { FormEvent, useEffect, useRef, useState } from "react";
import PageLoading from "../PageLoading/PageLoading";
import { useOutletContext } from "../../OutletContext";
import Swal from "sweetalert2";
import { adminPermissionsType } from "../../types";
import { Divider, Typography } from "@mui/material";

const SubAccount = () => {
    const cookies = new Cookies(null, {path: '/'});
    const [loading, setLoading] = useState<boolean>(false);
    const context = useOutletContext();
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    const [listSubAcc, setListSubAcc] = useState<{username: string}[]>([]);

    const usernameRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    useEffect(() => {
        getSubAccount();
    }, []);

    const getSubAccount = async () => {
        try {
            const service = new ApiService();
            const getSubAcc = await service.getSubAccount(cookies.get('access_token'));

            if(getSubAcc.data.status_code === 200)
            {
                setListSubAcc(getSubAcc.data.sub_agent);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleRequest = async (e: FormEvent) => {
        e.preventDefault();

        setLoading(true);
        try {
            if(!usernameRef.current || !passwordRef.current)
            {
                return;
            }

            const username = usernameRef.current.value.trim();
            const password = passwordRef.current.value.trim();

            if(username === '' || password === '')
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Notification',
                    text: 'Data is incomplete !'
                });
            }
            else
            {
                const service = new ApiService();
                const request = await service.createNewSubAccount(cookies.get('access_token'), username, password);

                if(request.data.status_code === 200)
                {
                    getSubAccount();
                    Swal.fire({
                        icon: 'success',
                        title: 'Notification',
                        text: 'Create successful'
                    });
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Notification',
                        text: `Create new sub account fail (${request.data.status_code} - ${request.data.message})`
                    });
                }
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            <div className="row">
                <div className="col-sm-12 col-md-6 mb-3">
                    <div className="card">
                        <div className="card-body">
                            <Typography component={'h1'} fontSize={22}>
                                Create new sub account
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <form id="formRequestTransaction" className="mb-3" onSubmit={handleRequest}>
                                <div className="mb-1">
                                    <label htmlFor="username_sub_agent" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Username
                                    </label>
                                    <input type="text" className="form-control" id="username_sub_agent" name="username_sub_agent"
                                        placeholder="Username" ref={usernameRef} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password_sub_agent" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Password
                                    </label>
                                    <input type="text" className="form-control" id="password_sub_agent" name="password_sub_agent"
                                        placeholder="Password" ref={passwordRef} />
                                </div>
                                <button className="btn btn-primary d-grid w-100" type="submit">Create new</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 mb-3">
                    <div className="card">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="border-top">
                                    <tr>
                                        <th align="center">
                                            <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                                USERNAME
                                            </Typography>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        listSubAcc.length > 0 ? listSubAcc.map((element: {username: string}, index: number) => {
                                            return (
                                                <tr key={`sub-acc-${index}`}>
                                                    <td>
                                                        <Typography align="center" fontSize={`0.95rem`}>
                                                            {
                                                                element.username
                                                            }
                                                        </Typography>
                                                    </td>
                                                </tr>
                                            )
                                        }) : <tr>
                                            <td colSpan={1}>
                                                <Typography align="center" fontSize={`0.95rem`}>
                                                    NOT FOUND SUB ACCOUNT
                                                </Typography>
                                            </td>
                                        </tr>
                                    }
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubAccount;